import React from "react";
import styled from "styled-components";
import { ReactComponent as Wrong } from "../assets/svg/wrong.svg";
import Button from "./Button";
import UserAPI from "../apis/UserAPI";
import { useHistory } from "react-router-dom";

const Blocked = () => {
  let history = useHistory();

  return (
    <Container>
      <Wrapper>
        <Icon as={Wrong} />
        <Description>
          Tu cuenta está registrada en otro dispositivo. Comunícate con el
          equipo de RaDi si deseas cambiar de dispositivo.
        </Description>
        <Buttons>
          <ButtonStyled
            text="Cerrar sesión"
            secondary
            onClick={() => UserAPI.logout()}
          />
          <ButtonStyled
            text="Reintentar"
            primary
            onClick={() => history.push("/home")}
          />
        </Buttons>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Icon = styled.div`
  width: 90px;
  height: 90px;
  margin-bottom: 30px;
`;

const Description = styled.div`
  font-size: 0.9em;
  text-align: center;
  margin-bottom: 20px;
`;

const Wrapper = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 100%;

  padding: 5px;
  box-sizing: border-box;
`;

const ButtonStyled = styled(Button)`
  margin: 15px 0px;
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export default Blocked;
